import { render, staticRenderFns } from "./modal_permission_crud.vue?vue&type=template&id=5aa12e70"
import script from "./modal_permission_crud.vue?vue&type=script&lang=js"
export * from "./modal_permission_crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports